// extracted by mini-css-extract-plugin
module.exports = {"button":"Button--button--3B9Ox"};